export default (state, action) => {
  switch (action.type) {
    case 'SET_DOCUMENT':
      return {
        ...state,
        document: { href: window.location.href, payload: action.payload },
      }
    case 'SET_BREADCRUMBS':
      return {
        ...state,
        breadcrumbs: { href: window.location.href, payload: action.payload },
      }
    case 'SET_CONTENT_TAGS':
      return {
        ...state,
        contentTags: {
          href: window.location.href,
          payload: action.payload.contentTags,
        },
        contentTagsLoaded: action.payload.contentTagsLoaded,
      }
    default:
      return state
  }
}
